type StorageLike = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>

const getLocalStorage = (): StorageLike | undefined => {
  try {
    return typeof window === 'undefined' ? undefined : window.localStorage
  }
  catch {
    // Browsers can deny access to the localStorage property itself.
    return undefined
  }
}

/**
 * Persistence is optional. Keep the application usable in privacy contexts
 * where the browser denies storage access, rather than letting that denial
 * escape from Pinia or the installation history UI.
 */
export const safeLocalStorage: StorageLike = {
  getItem(key) {
    try {
      return getLocalStorage()?.getItem(key) ?? null
    }
    catch {
      return null
    }
  },
  setItem(key, value) {
    try {
      getLocalStorage()?.setItem(key, value)
    }
    catch {
      // Persistence is unavailable; retain the current in-memory state.
    }
  },
  removeItem(key) {
    try {
      getLocalStorage()?.removeItem(key)
    }
    catch {
      // Persistence is unavailable; there is no stored value to remove.
    }
  },
}
